











































import Vue from "vue";

import MultiCurrencyCashDetailsListTable from "@/views/App/Components/MultiCurrencyCashDetailsListTable.vue";

// model
import { InstallationContent } from "@/model/data/content/InstallationContent";
import { Machine } from "@/model/data/Machine";

export default Vue.extend({
    components: {
        MultiCurrencyCashDetailsListTable,
    },
    props: {
        installation: { type: Object as () => InstallationContent },
    },
    computed: {
        colsAttribute(): number {
            return this.$vuetify.breakpoint.mdAndDown ? 12 : 6;
        },
        machineCardsList(): Machine[] {
            return this.installation.machines.length > 1 ? this.installation.machines.filter((m) => m.model != "DropVault") : [];
        },
    },
});
